import React from "react";
import ProgramPageHeader from "./ProgramPageHeader";
import CourseSectionGrid from "./CourseSectionGrid";
import { API_URL } from "../../../config";
import QueryLoading from "../../animations/QueryLoading";
import InnerContentWrapper from "../../styles/InnerContentWrapper";
import useAxios from "axios-hooks";
import styled from "styled-components";
import { Route, Switch, Link, Redirect } from "react-router-dom";
import SectionComponent from "../section/SectionComponent";
import ProgramNavigation from "../ProgramNavigation";

const CourseComponentWrapper = styled.main`
  background: ${(props) => props.theme.lightGrey};
`;

const CourseComponent = ({ match, courses, userLoading, userData }) => {
  const [
    { data: completedTokens, loading: completedTokensLoading },
    getCompletedTokens,
  ] = useAxios({
    url: `${API_URL}/getCourseTokens/${match.params.courseId}`,
    method: "GET",
    withCredentials: true,
  });
  // Filter courses
  const filteredCourse = courses.filter(
    (course) => match.params.courseId === course.courseId
  );
  let course = undefined;
  if (filteredCourse.length > 0) {
    course = filteredCourse[0];
  }
  if (!course) {
    return <Redirect to="/courses" />;
  }

  // Create an array of objects with post id and main category id
  const totalLessonsArray = [];
  for (const mainCategory of course.mainCategories) {
    for (const subCategory of mainCategory.subCategories) {
      for (const programPost of subCategory.programPosts) {
        totalLessonsArray.push({
          programPostId: programPost.programPostId,
          mainCategoryId: mainCategory.mainCategoryId,
        });
      }
    }
  }

  if (completedTokensLoading) return <QueryLoading />;
  // Check how many total lessons are completed

  return (
    <Switch>
      <Route
        path={`${match.url}/section/:sectionId`}
        render={(props) => (
          <SectionComponent
            userLoading={userLoading}
            userData={userData}
            course={course}
            completedTokens={completedTokens}
            totalLessonsArray={totalLessonsArray}
            getCompletedTokens={getCompletedTokens}
            {...props}
          />
        )}
      />
      <Route path={match.url}>
        <CourseComponentWrapper>
          <ProgramPageHeader
            introPicture={course.courseImage}
            programMainCategories={course.mainCategories}
            completedTokens={completedTokens}
            totalLessonsArray={totalLessonsArray}
            courseId={course.courseId}
            courseTitle={course.courseTitle}
          />
          <InnerContentWrapper>
            <ProgramNavigation>
              <span>
                <Link to={`/`}>My Courses</Link>
              </span>{" "}
              / <span>{course.courseTitle}</span>
            </ProgramNavigation>
            <CourseSectionGrid
              programData={course.mainCategories}
              completedTokens={completedTokens}
              totalLessonsArray={totalLessonsArray}
              currentPath={match.url}
            />
          </InnerContentWrapper>
        </CourseComponentWrapper>
      </Route>
    </Switch>
  );
};

export default CourseComponent;
